export const cart = {
  subscriptionTitle: 'Subscription',
  oneTimeTitle: 'One time Purchase',
  giftCartTitle: 'Gift Order',
  oneTimeDescription: 'These items will be delivered with your first subscription order:',
  oneTimeCarouselTitle: 'You Might Also Like',
  clearCartText: 'Clear Products',
  oneTimeCarouselAddButton: 'Add',
  title: 'Your Cart',
  checkoutButtonLabel: 'Checkout',
  emptyState: {
    oneTimeProductsTitle: 'Members Favorites',
    addOneTimeProductButton: 'Add to Cart',
    label: 'Add items to your cart'
  },
  emptyStateLabel: 'Add items to your cart',
  frequencyLabel: 'Ships every 30 days:',
  deliveryInfo:
    'When you complete checkout, you will be charged and this order will ship within 24 hours M-F after payment. Please allow up to 48 hours on weekends and holidays.',
  deleteItemModal: {
    title: 'Delete Items From Cart',
    description: 'Are you sure you are want to delete items from Cart?'
  },
  clearCartModal: {
    title: 'Remove All Items From Cart',
    description: 'Are you sure you are want to remove all items from Cart?'
  },
  free: 'Free',
  scoopPrompt: 'Need a scoop with your pouch? Add it below for free.'
};
